import { useMemo } from 'react';
import { getCurrentConsumptionModeType, getRestaurantId } from 'state/app';
import { useAppSelector } from 'state/store';
import { getConsumptionModeList } from 'state/consumptionModeList';
import { getPaymentMethodId, useCreateOrder } from 'hooks/useCreateOrder';
import { PaymentMode } from 'pages/Payment/ChoosePayment/useChoosePaymentVM';
import { PaygreenMetadata } from '../useCreateOrder/useCreateOrder.utils';

export const useConfirmPayment = (paymentMode: PaymentMode | undefined) => {
    const restaurantId = useAppSelector(getRestaurantId);
    const currentConsumptionModeType = useAppSelector(getCurrentConsumptionModeType);
    const consumptionModeList = useAppSelector(getConsumptionModeList);

    const { createOrder, isLoading } = useCreateOrder();

    const paymentMethodId: number | undefined = useMemo(
        () =>
            paymentMode &&
            getPaymentMethodId({
                paymentMode,
                consumptionModeList: consumptionModeList?.[restaurantId!],
                currentConsumptionModeType,
            }),
        [paymentMode, currentConsumptionModeType, consumptionModeList, restaurantId],
    );

    const handlePaymentSubmit = async ({
        stripePaymentMethodId,
        edenredAccessToken,
        paygreenMetadata,
    }: {
        stripePaymentMethodId?: string;
        edenredAccessToken?: string;
        paygreenMetadata?: PaygreenMetadata;
    } = {}) => {
        await createOrder({
            paymentMode,
            stripePaymentMethodId,
            paymentMethodId,
            edenredAccessToken,
            paygreenMetadata,
        });
    };

    return { handlePaymentSubmit, isLoadingCreateOrder: isLoading };
};
